import { render, staticRenderFns } from "./customer-user-modify.vue?vue&type=template&id=206dc6de&"
import script from "./customer-user-modify.vue?vue&type=script&lang=js&"
export * from "./customer-user-modify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports